<template>
  <div>
    <div class="flex w-full items-center justify-between">
      <h3 class="text-gray-600 font-semibold mb-3">Modo de registro de avance</h3>
      <b-tooltip v-if="canEditConfig"
        :label="'Configurar'"
        position="is-left"
      >
        <div
          class="flex items-center justify-center w-8 h-8 rounded-md bg-blue-lighter hover:bg-blue cursor-pointer"
          @click.stop="_HandleClickedConfigLayer"
        >
          <b-icon pack="fas" icon="cog" class="text-white text-xs" />
        </div>
      </b-tooltip>
    </div>
    <div class="space-y-3 text-sm text-gray-700">

      <div class="flex items-start gap-2">
        <span class="font-medium text-gray-800">Metodo de registro de avance: </span>
        <div class="flex items-center gap-1">
          <span>{{ avanceMethodSelected ? avanceMethodSelected.text : 'No definido' }}</span>
          <b-tooltip v-if="avanceMethodSelected"
            :label="avanceMethodSelected.description"
            multilined
            position="is-top"
          >
            <b-icon pack="fas" icon="question-circle" class="text-blue-lighter hover:text-blue cursor-help text-xs" />
          </b-tooltip>
        </div>
      </div>

      <div class="flex items-start gap-2">
        <span class="font-medium text-gray-800">Criterio de ponderación: </span>
        <div class="flex items-center gap-1">
          <span>{{ weightingCriteriaSelected ? weightingCriteriaSelected.text :'No definido' }}</span>
          <b-tooltip v-if="weightingCriteriaSelected"
            :label="weightingCriteriaSelected.description"
            multilined
            position="is-top"
          >
            <b-icon pack="fas" icon="question-circle" class="text-blue-lighter hover:text-blue cursor-help text-xs" />
          </b-tooltip>
        </div>
      </div>

      <div class="flex w-full items-center justify-between">
        <h3 class="text-gray-600 font-semibold">Visibilidad de los estados</h3>
      </div>

      <div class="flex items-start gap-2">
        <span class="font-medium text-gray-800">Estados de progreso: </span>
        <div class="flex items-center gap-1">
          <span>{{ progressVisibilitySelected ? progressVisibilitySelected.text : 'No definido' }}</span>
          <b-tooltip v-if="progressVisibilitySelected"
            :label="progressVisibilitySelected.description"
            multilined
            position="is-top"
          >
            <b-icon pack="fas" icon="question-circle" class="text-blue-lighter hover:text-blue cursor-help text-xs" />
          </b-tooltip>
        </div>
      </div>

      <div class="flex items-start gap-2">
        <span class="font-medium text-gray-800">Estados de incidencia: </span>
        <div class="flex items-center gap-1">
          <span>{{ incidentsVisibilitySelected ? incidentsVisibilitySelected.text : 'No definido' }}</span>
          <b-tooltip v-if="incidentsVisibilitySelected"
            :label="incidentsVisibilitySelected.description"
            multilined
            position="is-top"
          >
            <b-icon pack="fas" icon="question-circle" class="text-blue-lighter hover:text-blue cursor-help text-xs" />
          </b-tooltip>
        </div>
      </div>

      <div class="flex w-full items-center justify-between">
        <h3 class="text-gray-600 font-semibold">Permitir multiple registro de estados</h3>
      </div>

      <div class="flex items-start gap-2">
        <span class="font-medium text-gray-800">Estados de progreso: </span>
        <div class="flex items-center gap-1">
          <span>{{ progressSelectMultiple ? progressSelectMultiple.text : 'No definido' }}</span>
          <b-tooltip v-if="progressSelectMultiple"
            :label="progressSelectMultiple.description"
            multilined
            position="is-top"
          >
            <b-icon pack="fas" icon="question-circle" class="text-blue-lighter hover:text-blue cursor-help text-xs" />
          </b-tooltip>
        </div>
      </div>

      <div class="flex items-start gap-2">
        <span class="font-medium text-gray-800">Estados de incidencia: </span>
        <div class="flex items-center gap-1">
          <span>{{ incidentsSelectMultiple ? incidentsSelectMultiple.text : 'No definido' }}</span>
          <b-tooltip v-if="incidentsSelectMultiple"
            :label="incidentsSelectMultiple.description"
            multilined
            position="is-top"
          >
            <b-icon pack="fas" icon="question-circle" class="text-blue-lighter hover:text-blue cursor-help text-xs" />
          </b-tooltip>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { advanceMethodOptions, stateWeightingCriteriaOptions,
  statusesVisibilityOptions, registerMultipleStatusesOptions } from '../../data/select.options.js'

export default {
  // Renombrado para evitar la colisión con el editor real
  // `layer-statuses/LayerStatusesConfig.vue` (esta es la tarjeta de solo lectura).
  name: 'LayerStatusesConfigSummary',

  props: {
    data: {
      type: Object,
      default: null
    },
    codeLayer: {
      type: String,
      default: null
    },
    canEditConfig: {
      type: Boolean,
      default: true
    }
  },

  watch: {
    data: {
      handler(newVal) {
        this.config = {
          avance_method: newVal?.avance_method ?? null,
          weighting_criteria: newVal?.weighting_criteria ?? null,
          visibility: {
            progress: newVal?.visibility?.progress ?? 'visible_default',
            progress_roles: newVal?.visibility?.progress_roles ?? null,
            incidents: newVal?.visibility?.incidents ?? 'visible_default',
            incidents_roles: newVal?.visibility?.incidents_roles ?? null,
          },
          select_multiple: {
            progress: newVal?.select_multiple?.progress ?? 'single',
            incidents: newVal?.select_multiple?.incidents ?? 'single',
          }
        };
      },
      deep: true,
      immediate: true
    }
  },

  data() {
    return {
      advanceMethodOptions,
      stateWeightingCriteriaOptions,
      statusesVisibilityOptions,
      registerMultipleStatusesOptions,

      config: {
        avance_method: this.data?.avance_method ?? null,
        weighting_criteria: this.data?.weighting_criteria ?? null,
        visibility: {
          progress: this.data?.visibility?.progress ?? 'visible_default',
          progress_roles: this.data?.visibility?.progress_roles ?? null,
          incidents: this.data?.visibility?.incidents ?? 'visible_default',
          incidents_roles: this.data?.visibility?.incidents_roles ?? null,
        },
        select_multiple: {
          progress: this.data?.select_multiple?.progress ?? 'single',
          incidents: this.data?.select_multiple?.incidents ?? 'single',
        }
      },
    }
  },

  computed: {
    avanceMethodSelected() {
      return this.config.avance_method ? this.advanceMethodOptions.find(o => o.value === this.config.avance_method) : null;
    },
    weightingCriteriaSelected() {
      return this.config.weighting_criteria ? this.stateWeightingCriteriaOptions.find(o => o.value === this.config.weighting_criteria) : null;
    },
    progressVisibilitySelected() {
      return this.config.visibility?.progress ? this.statusesVisibilityOptions.find(o => o.value === this.config.visibility.progress) : 'visible_default';
    },
    incidentsVisibilitySelected() {
      return this.config.visibility?.incidents ? this.statusesVisibilityOptions.find(o => o.value === this.config.visibility.incidents) : 'visible_default';
    },
    progressRolesSelected() {
      return this.config.visibility?.progress_roles ? this.statusesVisibilityOptions.find(o => o.value === this.config.visibility.progress_roles) : null;
    },
    incidentsRolesSelected() {
      return this.config.visibility?.incidents_roles ? this.statusesVisibilityOptions.find(o => o.value === this.config.visibility.incidents_roles) : null;
    },
    progressSelectMultiple() {
      return this.config.select_multiple?.progress ? this.registerMultipleStatusesOptions.find(o => o.value === this.config.select_multiple.progress) : 'single';
    },
    incidentsSelectMultiple() {
      return this.config.select_multiple?.incidents ? this.registerMultipleStatusesOptions.find(o => o.value === this.config.select_multiple.incidents) : 'single';
    },
  },

  created() {
  },

  methods: {
    _HandleClickedConfigLayer() {
      this.$emit('epc-open-config-modal', {
        codeLayer: this.codeLayer,
        config: this.config
      });
    },
  }
}
</script>
